var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0568 1.33203H3.89034L3.88818 1.33203C3.21118 1.33404 2.56249 1.60386 2.08378 2.08256C1.60508 2.56127 1.33525 3.20996 1.33325 3.88695V10.0535L1.33325 10.0556C1.33501 10.6721 1.58071 11.2629 2.01666 11.6988C2.44263 12.1248 3.0164 12.3691 3.61758 12.3817C3.65645 13.6496 4.69647 14.6655 5.97376 14.6655H12.3094C13.6113 14.6655 14.6667 13.6101 14.6667 12.3082V5.97254C14.6667 4.69527 13.6508 3.65527 12.383 3.61637C12.3704 3.01518 12.1261 2.44141 11.7001 2.01544C11.2641 1.57948 10.6734 1.33379 10.0568 1.33203ZM10.9209 3.61523C10.9086 3.40217 10.8186 3.20034 10.6669 3.04866C10.5041 2.88591 10.2837 2.7941 10.0535 2.79322H3.89156C3.60094 2.79432 3.32252 2.91026 3.117 3.11577C2.91148 3.32129 2.79555 3.59971 2.79444 3.89032V10.0523C2.79533 10.2824 2.88714 10.5029 3.04988 10.6656C3.20157 10.8173 3.4034 10.9074 3.61646 10.9196V5.97254C3.61646 4.67064 4.67186 3.61523 5.97376 3.61523H10.9209ZM5.07764 5.97254C5.07764 5.47763 5.47885 5.07642 5.97376 5.07642H12.3094C12.8043 5.07642 13.2055 5.47763 13.2055 5.97254V12.3082C13.2055 12.8031 12.8043 13.2043 12.3094 13.2043H5.97376C5.47885 13.2043 5.07764 12.8031 5.07764 12.3082V5.97254Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.b03f5de3e5fe078ebb318f3db70afe4a.svg";
export { ForwardRef as ReactComponent };